exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-student {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  margin: -1px 0;\n  padding: 10px;\n}\n.select-student h4 {\n  margin-right: 20px;\n  font-weight: normal;\n}\n.select-student .selection-controls {\n  display: flex;\n  flex-direction: row;\n}\n.select-student .grade-level-restriction {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin: 0;\n  width: 300px;\n}\n.select-student .grade-level-restriction .radio-inline label {\n  font-weight: normal;\n}\n.select-student .manual-selection,\n.select-student .no-students-found {\n  margin: 0 15px;\n  width: 300px;\n}\n.select-student .control-separator {\n  margin-right: 15px;\n  margin-top: 5px;\n}\n.select-student .random-selection {\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/SelectStudent.styl
// module id = 1914
// module chunks = 1